var _rect, _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSidebarBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "canvas",
    viewBox: "0 0 1920 1080",
    preserveAspectRatio: "xMaxYMid slice",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1080,
    fill: "hsl(308, 65%, 15%)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0.5,
    y1: 0,
    x2: 0,
    y2: 1,
    id: "SvgjsLinearGradient1028"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5d288a",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#14060c",
    offset: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0.5,
    y1: 0,
    x2: 0,
    y2: 1,
    id: "SvgjsLinearGradient1029"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#84288a",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#140607",
    offset: 0.22857142857142856
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0.5,
    y1: 0,
    x2: 0,
    y2: 1,
    id: "SvgjsLinearGradient1030"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#84288a",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#140607",
    offset: 0.3571428571428571
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0.5,
    y1: 0,
    x2: 0,
    y2: 1,
    id: "SvgjsLinearGradient1031"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#dac0f2",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#d74287",
    offset: 0.48571428571428565
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0.5,
    y1: 0,
    x2: 0,
    y2: 1,
    id: "SvgjsLinearGradient1032"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#d0c0f2",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#d742a5",
    offset: 0.6142857142857142
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0.5,
    y1: 0,
    x2: 0,
    y2: 1,
    id: "SvgjsLinearGradient1033"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#dac0f2",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#d74287",
    offset: 0.7428571428571429
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0.5,
    y1: 0,
    x2: 0,
    y2: 1,
    id: "SvgjsLinearGradient1034"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#dac0f2",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#d74287",
    offset: 0.8714285714285713
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0,-579.5059438065471C52.46880001781498,-566.3436731245231,199.54425979654877,-539.7176927008034,314.8128001068899,-500.53231971440346C430.081340417231,-461.3469467280035,579.2589327894834,-381.96732740743636,691.6112418620465,-344.39370588814734C803.9635509346097,-306.8200843688583,888.3592557724246,-301.8679894175013,988.9266545422685,-275.0905905986693C1089.4940533121123,-248.31319177983727,1195.503449801211,-207.61860920651432,1295.0156344811096,-183.72931297515524C1394.5278191610082,-159.84001674379616,1481.8357017018457,-155.79204140528287,1585.9997626216607,-131.75481321051484C1690.1638235414757,-107.7175850157468,1864.3332937702767,-54.880755373875004,1920,-39.50594380654704L 1920 1080 L 0 1080 Z",
    fill: "url(#SvgjsLinearGradient1028)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0,-391.3174317990836C66.82869497237759,-373.40468272001215,269.03884522341843,-321.1911931932048,400.9721698342655,-283.8409373246551C532.9054944451126,-246.4906814561054,668.8958098454865,-200.62453477635015,791.5999476650825,-167.21589658778535C914.3040854846785,-133.80725839922056,1016.1783690743163,-121.33583012945209,1137.1969967518412,-83.38910819326635C1258.215624429366,-45.44238625708062,1387.2445465222056,19.404869916012842,1517.711713730232,60.464435029329024C1648.1788809382585,101.5240001426452,1852.951952288372,145.88430791041378,1920,162.96828248663073L 1920 1080 L 0 1080 Z",
    fill: "url(#SvgjsLinearGradient1029)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0,-292.3990864133629C40.789563945795905,-284.167755461901,144.2954935512082,-272.3412903540967,244.73738367477543,-243.0111007045912C345.17927379834265,-213.6809110550857,499.4733214218251,-146.61804584184526,602.6513407414034,-116.41794851632977C705.8293600609817,-86.21785119081429,786.1335674822556,-82.54108998195969,863.805499592245,-61.81051675149828C941.4774317022345,-41.07994352103687,987.9624920969352,-22.357688185852915,1068.68293340134,7.965490866438667C1149.403374705745,38.28866991873025,1248.6520094024283,91.89232851742003,1348.1281474186742,120.12855756225122C1447.60428543492,148.3647866070824,1570.2277860685936,151.37556770279008,1665.5397614988146,177.38286513542582C1760.8517369290357,203.39016256806156,1877.5899602498025,259.7074293209591,1920,276.1723421580657L 1920 1080 L 0 1080 Z",
    fill: "url(#SvgjsLinearGradient1030)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0,-146.52245464141004C44.43865746525972,-137.29676178117126,185.7297503157975,-111.82063844104569,266.63194479155834,-91.16829747997741C347.5341392673192,-70.51595651890914,412.752226997804,-47.1321248247479,485.41316685456496,-22.60840887500037C558.074106711326,1.9153070747471546,622.6474964373003,22.67492590647506,702.5975839321242,55.973998218507745C782.547671426948,89.27307053054042,882.3806406533485,153.54497326536585,965.1136918235078,177.18602499719574C1047.8467429936672,200.82707672902563,1125.3793180151656,174.8226296315873,1198.9958909530803,197.8203086094871C1272.612463890995,220.81798758738694,1330.1473387248227,290.9658141703425,1406.8131294509967,315.1720988645948C1483.4789201771707,339.378383558847,1573.4594902186243,322.86425188314416,1658.9906353101248,343.0580167750005C1744.5217804016254,363.25178166685686,1876.4984392183542,420.78857630894413,1920,436.33468821573285L 1920 1080 L 0 1080 Z",
    fill: "url(#SvgjsLinearGradient1031)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0,-67.21969288570004C50.88052321596746,-51.9626481758414,199.76634880046754,-3.368912886080331,305.28313929580474,24.32257537345179C410.79992979114195,52.01406363298391,526.2733408708169,67.89661058258325,633.1007429720232,98.92923667149267C739.9281450732295,129.9618627604021,838.118956014661,176.81205561296085,946.2475519030424,210.51833190690837C1054.376147791424,244.2246082008559,1178.440774603071,268.6645618897352,1281.8723183023124,301.1668944351778C1385.3038620015536,333.66922698062046,1460.4822004822086,367.4062822092344,1566.8368140984899,405.5323271795643C1673.1914277147712,443.65837214989415,1861.139469016415,509.19135807755833,1920,529.9231642571572L 1920 1080 L 0 1080 Z",
    fill: "url(#SvgjsLinearGradient1032)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0,135.54674940993678C53.257459161940034,157.22581576098582,233.66783626685208,233.042763789183,319.5447549716402,265.6211475162311C405.4216736764283,298.1995312432791,430.18538148847733,317.6655129759864,515.2615122287287,331.0170517722252C600.3376429689802,344.368590568464,739.1291517529569,318.21001347098013,830.0015394131487,345.7303802936639C920.8739270733406,373.2507471163477,969.5007820097119,454.706771651416,1060.49583818988,496.139252708328C1151.4908943700482,537.57173376524,1273.1408918345373,575.1052565773105,1375.9718764941579,594.325266635136C1478.8028611537784,613.5452766929616,1586.8103922299622,586.0176373547197,1677.4817461476025,611.4593130552817C1768.1531000652428,636.9009887558436,1879.5802910246005,724.3893195413037,1920,746.9753208385082L 1920 1080 L 0 1080 Z",
    fill: "url(#SvgjsLinearGradient1033)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0,248.5530990646245C54.91859668544917,261.22613721388984,228.1118952692434,286.4664883398241,329.511580112695,324.5913279602165C430.9112649561466,362.71616758060895,507.96160208488857,437.1532098100309,608.3981090607098,477.30213678697925C708.834616036531,517.4510637639276,823.8322900779018,528.7231322854085,932.1306219676223,565.4848898219067C1040.4289538573428,602.2466473584049,1149.6115574665841,659.8328609739326,1258.188100399033,697.872682005968C1366.7646433314817,735.9125030380035,1473.2878962954878,764.3246988852952,1583.5898795623157,793.7238160141189C1693.8918628291435,823.1229331429427,1863.9316465937193,860.843456651445,1920,874.2673847789102L 1920 1080 L 0 1080 Z",
    fill: "url(#SvgjsLinearGradient1034)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarBg);
export default __webpack_public_path__ + "static/media/sidebar-bg.3eed74455840207420a03d85329a675f.svg";
export { ForwardRef as ReactComponent };